/**
 * /tenants/$slug/access-governance/recovery — retired path of the user-recovery
 * desk, which now lives at /locked-out-users under People.
 * Bookmarks and emailed links keep resolving.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/tenants/$slug/access-governance/recovery")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/tenants/$slug/locked-out-users", params: { slug: params.slug } });
  },
});
